import React, { useMemo } from "react";
import { TargetTypeEnum } from "../../../classes/enums/SppEnum";
import SppWidget from "../../common/spp/SppWidget";
import "../../common/spp/SppWidget.css";
import ValidationFlag from "../../validation/validationFlag/ValidationFlag";

const CheckSpp = ({
  measurementConfigs,
  customMeasurementConfigs,
  onSppSelected,
  onSppSelectedCustom,
  activeParameters,
  removeCustomParameter,
  instances,
  refresh,
  selectedTargetType = TargetTypeEnum.GAP,
  onTargetTypeChange,
  digitalTwinId = null,
  initialKeyParameters = [],
  modalityContext = null,
  originalMeasurements = {},
}) => {
  const updateParamsWithValues = useMemo(
    () => params => {
      return params.map(param => ({
        ...param,
        originalValue: (() => {
          const key = Number(param.key ?? param.unique_identifier);
          if (Number.isFinite(key) && originalMeasurements.hasOwnProperty(key)) {
            return originalMeasurements[key];
          }
          return undefined;
        })(),
      }));
    },
    [originalMeasurements]
  );

  if (!measurementConfigs) {
    return (
      <div>
        <ValidationFlag modalityContext={modalityContext} />
        <div>Loading measurements...</div>
      </div>
    );
  }

  return (
    <div className="App-spp-widget">
      <ValidationFlag
        instances={instances}
        refresh={refresh}
        modalityContext={modalityContext}
      />
      <SppWidget
        isOctView={false}
        updateParamsWithValues={updateParamsWithValues}
        onSppSelected={onSppSelected}
        onSppSelectedCustom={onSppSelectedCustom}
        removeCustomParameter={removeCustomParameter}
        activeParameters={activeParameters}
        measurementConfigs={measurementConfigs}
        customMeasuramentConfigs={customMeasurementConfigs}
        selectedTargetType={selectedTargetType}
        onTargetTypeChange={onTargetTypeChange}
        digitalTwinId={digitalTwinId}
        initialKeyParameters={initialKeyParameters}
      />
    </div>
  );
};

export default React.memo(CheckSpp);
